/*!
 * JavaScript for GAYL Online Startpage site
 * Give as you Live Ltd
 */

// Import SASS/SCSS styles
import 'Sass/startpage.scss';

// Import JavaScript modules
import Dropdown from 'Vendor/bootstrap/js/dist/dropdown';

// Import modules
const Loader      = require('Scripts/common/loader');
const OwlCarousel = require('Scripts/common/owl-carousel');
const StartPage   = require('Scripts/startpage/startpage');

// Define groups of modules - the group name is set in your template ($jsModuleGroup). 
// This is just a nicer way to load JS on specific pages without looking at the path/params
// To initiate a group, use the #module macro. E.g. #module("my-group") would add 'my-group' from the groups below.
const moduleGroups = {
	// Available on every page
	'global': [StartPage, OwlCarousel],
};

Loader.load(moduleGroups);